import type { ElementType, ReactNode } from 'react';

/** Screen-reader-only content (chart data tables, SR summaries). */
export function VisuallyHidden({ children, as }: { children: ReactNode; as?: ElementType }) {
  const Tag = as ?? 'span';
  return <Tag className="visually-hidden">{children}</Tag>;
}
